import React from "react";

const TIERS = [
  { label: "Everything, all at once", title: "Thousands of data points, weighed and scored", detail: "prices · headlines · news · social posts · earnings · the strength of the words", w: "max-w-full", bg: "#2A1650", border: "#4C2A8A", accent: "#C4B5FD" },
  { label: "The mood of the market", title: "Synthesized from all of it — one read:", detail: "BOLD ←→ SCARED", w: "max-w-[94%] sm:max-w-[84%]", bg: "#3B1D73", border: "#6B3FC2", accent: "#DDD6FE" },
  { label: "Where the money’s moving", title: "Sector by sector, ranked", detail: "TECH ↑ · ENERGY ↑ · BANKS → · HEALTHCARE ↓", example: true, w: "max-w-[88%] sm:max-w-[68%]", bg: "#5B2BB0", border: "#8B5CF6", accent: "#EDE9FE" },
  { label: "Today’s move", title: "Buy · Take profits · Play defense · Wait", w: "max-w-[82%] sm:max-w-[52%]", bg: "#7C3AED", border: "#C4B5FD", accent: "#FFFFFF", final: true },
];

export const HowItWorksFunnel = () => (
  <div className="mt-10 rounded-2xl p-5 sm:p-8 lg:p-10 border border-white/10" style={{ background: "#0B0716" }} data-testid="how-it-works-funnel">
    <div className="flex flex-col items-center gap-2.5">
      {TIERS.map((t, i) => (
        <div
          key={t.label}
          className={`rounded-xl px-4 sm:px-6 py-4 text-center w-full fade-in-up ${t.w}`}
          style={{ background: t.bg, border: `1px solid ${t.border}`, animationDelay: `${i * 90}ms` }}
          data-testid={`funnel-tier-${i + 1}`}
        >
          <div className="text-xs sm:text-sm" style={{ color: t.accent }}>
            {i + 1} · {t.label}
          </div>
          <div className={`mt-1 font-serif-hero text-white ${t.final ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl"}`}>{t.title}</div>
          {t.detail && (
            <div className="mt-1 text-xs sm:text-sm text-white/75">
              {t.example && <span className="mr-1.5 rounded-full px-2 py-0.5 text-[10px] bg-white/15 text-white" data-testid="funnel-example-tag">Example</span>}
              {t.detail}
            </div>
          )}
        </div>
      ))}
    </div>
    <p className="mt-5 text-center text-sm text-white/55" data-testid="funnel-footnote">
      No action is a decision too. Example shown for illustration.
    </p>
  </div>
);

export const HeroSteps = () => (
  <div className="mt-6 inline-flex flex-wrap items-center gap-x-3 gap-y-1 font-serif-hero text-2xl" data-testid="hero-steps-strip">
    <span className="text-violet-200">Everything</span>
    <span className="text-neutral-500">→</span>
    <span className="text-violet-300">the mood</span>
    <span className="text-neutral-500">→</span>
    <span className="text-white italic">today’s move</span>
  </div>
);
